let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6k2ZI")).then(() => parcelRequire('fECc8'));